module.exports = __webpack_public_path__ + "img/status-online-list.b1283ee2.gif";